export const environment = {
  baseUrl: 'https://backendadhd.dev.ttcdevs.com/api/',
  socketUrl: 'https://backendadhd.dev.ttcdevs.com',
  backendSecretKey: 'KUNU-VolkovIndia-7777',
  localStorageSecretKey: 'beautiful129*876 Rashmi',
  adminUrl: '/admin',
  acccountManagerUrl: '/account-manager',
  areaManagerUrl: '/area-manager',
  serviceEngineerUrl: '/service-engineer',
  appUrl: 'https://adhd.dev.thetechclouds.com',
  clientId: 'ff78f53b-b24a-4968-bac8-f68db917c931',
  allowed_countries: ['UK', 'IE', 'AT', 'BE', 'FR', 'DE', 'NL', 'PL'],
  authority:
    'https://login.microsoftonline.com/dea1c8f9-cc9f-411d-b3e5-bad39fe9732e',
  guestUrl: '/guest',
  googlePlaceApiKey: 'AIzaSyAUc5KPygalKXNqkFmLtyL0ZurvXTl4mGM',
  clarityProjectId: 'yfkrdwxoew',
};
